import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProgressSpinnerModule} from './components/progress-spinner/progress-spinner.module';
import {EmailFieldComponent} from './components/email-field/email-field.component';
import {PasswordFieldComponent} from './components/password-field/password-field.component';
import {SessionTimeoutDialogComponent} from './components/session-timeout-dialog/session-timeout-dialog.component';
import { EnumFormatterPipe } from './pipes/enum-formatter.pipe';

@NgModule({
    declarations: [EmailFieldComponent, PasswordFieldComponent, SessionTimeoutDialogComponent],
    imports: [
        CommonModule,
        ProgressSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        EnumFormatterPipe
    ],
    exports: [ProgressSpinnerModule, EmailFieldComponent, PasswordFieldComponent, SessionTimeoutDialogComponent, EnumFormatterPipe]
})
export class SharedModule {
}
